import { useEffect, useState } from "react";


export default function useTypewriter(text, speed = 100) {
  const [displayText, setDisplayText] = useState("");
  const [index, setIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isDeleting) {
        // Typing
        if (index < text.length) {
          setDisplayText(text.slice(0, index + 1));
          setIndex(index + 1);
        } else {
          setTimeout(() => setIsDeleting(true), 1000);
        }
      } else {
        // Deleting
        if (index > 0) {
          setDisplayText(text.slice(0, index - 1));
          setIndex(index - 1);
        } else {
          setIsDeleting(false);
        }
      }
    }, speed);

    return () => clearInterval(interval);
  }, [index, isDeleting, text, speed]);

  return displayText;
}